export interface SegmentOverviewPeriod {
  start_date: string
  end_date: string
  ly_start_date: string
  ly_end_date: string
}

export interface SegmentOverviewSummary {
  total_count: number
  total_count_ly: number
  yoy_abs: number
  yoy_pct: number | null
  leasing_count: number
  leasing_pct: number
  segment_count: number
  period: SegmentOverviewPeriod
}

export interface SegmentOverviewRow {
  segment_id: number
  segment_name: string
  count: number
  count_ly: number
  yoy_abs: number
  yoy_pct: number | null
  market_share: number
  leasing_count: number
  leasing_pct: number
}

export interface SegmentOverviewResponse {
  summary: SegmentOverviewSummary
  data: SegmentOverviewRow[]
}

export interface SegmentTopModelsSummary {
  segment_id: number
  segment_name: string
  segment_count: number
  market_share_of_total: number
  segment_count_ly: number
  yoy_abs: number
  yoy_pct: number | null
  leasing_pct: number
  model_count: number
  period: SegmentOverviewPeriod
}

export interface SegmentTopModelsRow {
  rank: number
  brand_key: string
  brand_name: string
  master_model_id: number
  master_model: string
  count: number
  segment_share_pct: number
  count_ly: number
  yoy_abs: number
  yoy_pct: number | null
  leasing_pct: number
}

export interface SegmentTopModelsResponse {
  segment_summary: SegmentTopModelsSummary
  data: SegmentTopModelsRow[]
}

// Logical display order for segment tabs: size progression, then special categories
// Small → Small SUV → Compact → Compact SUV → Medium → Medium SUV → Large → Large SUV → Terrain → Pickup → MPV → Sport → Other
export const SEGMENT_DISPLAY_ORDER: number[] = [
  2,   // Small
  12,  // Small SUV
  10,  // Compact
  3,   // Compact SUV
  11,  // Medium
  1,   // Medium SUV
  4,   // Large
  5,   // Large SUV
  13,  // Terrain
  7,   // Pickup
  15,  // MPV
  9,   // Sport
  14,  // Other
]

// Distinct colors keyed by segment_id (1-15, excluding 6 and 8)
export const SEGMENT_COLORS: Record<number, string> = {
  1: '#3b82f6',   // Medium SUV
  2: '#10b981',   // Small
  3: '#f59e0b',   // Compact SUV
  4: '#ef4444',   // Large
  5: '#8b5cf6',   // Large SUV
  7: '#14b8a6',   // Pickup
  9: '#06b6d4',   // Sport
  10: '#84cc16',  // Compact
  11: '#f97316',  // Medium
  12: '#ec4899',  // Small SUV
  13: '#a855f7',  // Terrain
  14: '#6b7280',  // Other
  15: '#eab308',  // MPV
}
